import { render, staticRenderFns } from "./ClosingDate.vue?vue&type=template&id=88008abc&"
import script from "./ClosingDate.vue?vue&type=script&lang=js&"
export * from "./ClosingDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88008abc')) {
      api.createRecord('88008abc', component.options)
    } else {
      api.reload('88008abc', component.options)
    }
    module.hot.accept("./ClosingDate.vue?vue&type=template&id=88008abc&", function () {
      api.rerender('88008abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/ClosingDate.vue"
export default component.exports